// @ts-strict-ignore
import React from 'react';
import NavigateBack from './NavigateBack';
import { goBack } from '../../../store/RouteState.model';
import { HOME_ROUTE } from '../../../route-names';

type NavigateBackContainerProps = {
  /** Called after back has been pressed and navigation has begun */
  onBackPress?: () => void;
  renderFunc?: (onPress: () => void) =>
  ReturnType<React.FCWithChildren<NavigateBackContainerProps>>;
};

const handleBack = () => (goBack(HOME_ROUTE, undefined, undefined));

const NavigateBackContainer: React.FCWithChildren<NavigateBackContainerProps> = ({
  onBackPress,
  renderFunc,
}) => {
  const handleBackPress = () => {
    handleBack();
    onBackPress?.();
  };

  if (renderFunc) {
    return renderFunc(handleBackPress);
  }
  return (
    <NavigateBack onPress={handleBackPress} />
  );
};

export default NavigateBackContainer;
